import React from 'react';

const testimonials = [
  {
    text: '“Nurturix has really helped us grow and manage our leads, love it!”',
    img: 'https://randomuser.me/api/portraits/men/31.jpg',
    name: 'Name 1',
    desc: 'Description 1',
  },
  {
    text: '“A fantastic bit of feedback”',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
    name: 'Name 2',
    desc: 'Description 2',
  },
  {
    text: '“A genuinely glowing review”',
    img: 'https://randomuser.me/api/portraits/men/50.jpg',
    name: 'Name 3',
    desc: 'Description 3',
  },
  {
    text: '“A fantastic bit of feedback”',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
    name: 'Name 4',
    desc: 'Description 4',
  }
];

const Testimonials = () => (
  <section
    className="py-5 px-4"
    style={{ backgroundColor: '#f1bcbc' }} // darker creamy red-pink
  >
    <div className="container">
      <h2 className="mb-4 text-start">Companies Love our Product</h2>
      <div className="d-flex justify-content-start flex-wrap gap-4">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-white p-4 rounded shadow-sm"
            style={{ width: '300px', fontSize: '1.05rem' }}
          >
            <p className="fst-italic mb-3">{t.text}</p>
            <img
              src={t.img}
              alt={`user-${i}`}
              className="rounded-circle mb-2"
              width={50}
              height={50}
            />
            <div>
              <strong>{t.name}</strong><br />
              <small>{t.desc}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
